/**
 *
 * Asynchronously loads the component for Statistic
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Statistic/Loadable.js